export const MULTI_TENANT_MAPPING_CONSTANTS = {
  GET_USERS_MAPPED_TO_TENANTS: "GET_USERS_MAPPED_TO_TENANTS",
  ALL_KEYCLOAK_TENANTS: "ALL_KEYCLOAK_TENANTS",
  GROUP_AND_TENANT_NAMES: "GROUP_AND_TENANT_NAMES",
};
